import api from '../../../../services/api';

// Auto Messages Actions
export const FETCH_AUTO_MESSAGES_START = 'FETCH_AUTO_MESSAGES_START';
export const FETCH_AUTO_MESSAGES_SUCCESS = 'FETCH_AUTO_MESSAGES_SUCCESS';
export const FETCH_AUTO_MESSAGES_ERROR = 'FETCH_AUTO_MESSAGES_ERROR';

export const UPDATE_AUTO_MESSAGE_START = 'UPDATE_AUTO_MESSAGE_START';
export const UPDATE_AUTO_MESSAGE_SUCCESS = 'UPDATE_AUTO_MESSAGE_SUCCESS';
export const UPDATE_AUTO_MESSAGE_ERROR = 'UPDATE_AUTO_MESSAGE_ERROR';

// Fetch all auto messages
export const fetchAutoMessages = () => async (dispatch) => {
    dispatch({ type: FETCH_AUTO_MESSAGES_START });
    try {
        const response = await api.get('/application-settings/auto-messages');
        console.log('API Response:', response.data); // Debug log
        
        const messages = response.data?.data || {};
        
        dispatch({ 
            type: FETCH_AUTO_MESSAGES_SUCCESS, 
            payload: messages
        });
        return { success: true, data: messages };
    } catch (error) {
        console.error('Error fetching auto messages:', error);
        dispatch({ 
            type: FETCH_AUTO_MESSAGES_ERROR, 
            payload: 'Không thể tải danh sách tin nhắn tự động' 
        });
        return { success: false, error: error.message };
    }
};

// Update an auto message
export const updateAutoMessage = (messageType, messageContent) => async (dispatch) => {
    dispatch({ type: UPDATE_AUTO_MESSAGE_START });
    try {
        const response = await api.put('/application-settings/auto-messages', {
            messageType,
            messageContent
        });
        
        const updatedMessage = response.data?.data || response.data;
        dispatch({ 
            type: UPDATE_AUTO_MESSAGE_SUCCESS, 
            payload: { messageType, messageContent: updatedMessage.value }
        });
        return { success: true, data: updatedMessage };
    } catch (error) {
        console.error('Error updating auto message:', error);
        dispatch({ 
            type: UPDATE_AUTO_MESSAGE_ERROR, 
            payload: 'Không thể cập nhật tin nhắn tự động' 
        });
        return { success: false, error: error.message };
    }
};